import React, { useState } from "react";

export const Context = React.createContext({});

export function UserContextProvider({ children }) {
  const [jwt, setJWT] = useState(() => window.localStorage.getItem("jwt"));
  const [msalInstance, onMsalInstanceChange] = useState();

  const logoutHandler = () => {
    window.sessionStorage.clear();
    window.localStorage.clear()
    setJWT(null);
    //setAccess(null)
    window.localStorage.removeItem("jwt");
    window.localStorage.removeItem("Access");
    //sessionStorage.clear();
    //msalInstance.logout();
    

  };
  const value = { jwt, setJWT, onMsalInstanceChange, logoutHandler };

  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export default Context;
